import { styled } from '@linaria/react';
import { blur, fonts, layout, semantic, space } from '../../theme/tokens';

export const CarouselWrapper = styled.div`
  width: 100%;
`;

export const CarouselHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${space[7]};
`;

export const CarouselTitle = styled.h2`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const ArrowGroup = styled.div`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    align-items: center;
    padding: ${space[1]};
    border-radius: ${layout.borderRadiusFull};
    background: ${semantic.bg.surfaceSubtle};
  }

  &[data-variant='blur'] {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(${blur.lg});
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  gap: ${space[5]};
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: var(--carousel-child-width-mobile, var(--carousel-child-width));

    @media (min-width: ${layout.desktopBreakpoint}) {
      width: var(--carousel-child-width);
    }
  }
`;

export const ProgressTrack = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${space[7]};
`;

export const ProgressBarOuter = styled.div`
  width: 240px;
  height: 4px;
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${layout.borderRadiusFull};
  overflow: hidden;
  position: relative;
`;

export const ProgressBarInner = styled.div`
  height: 100%;
  background: ${semantic.text.primary};
  border-radius: ${layout.borderRadiusFull};
  position: absolute;
  left: 0;
  transition: left 0.05s ease-out;
`;
